module.exports = __webpack_public_path__ + "media/main_theme.ffd5925c.mp3";